module.exports = __webpack_public_path__ + "static/media/9.716be386.png";